var locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/time-picker/locale/en_US.js
// module id = 239
// module chunks = 0